import { Navigate } from 'react-router-dom';

/**
 * Dedicated BOLT entry — simply reroutes to the breathing-practice page
 * with the `?challenge=bolt&bolt_only=1` flag so the switcher pills are
 * hidden and the patient lands straight on the BOLT test (mandatory
 * weekly measure prescribed in every program). Having a stable route
 * `/breathing/bolt` keeps the Mon Programme link short, memorable, and
 * easy to bookmark on an elderly patient's home screen.
 */
const BoltTestPage = () => (
  <Navigate to="/breathing/practice?challenge=bolt&bolt_only=1" replace />
);

export default BoltTestPage;
